import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface InstructionsProps {
  isOpen: boolean;
  onClose: () => void;
}

const Instructions: React.FC<InstructionsProps> = ({ isOpen, onClose }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="instructions-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          <motion.div
            className="instructions-content"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="instructions-header">
              <h2>How to Play Letterweave</h2>
              <button className="close-button" onClick={onClose}>
                ✕
              </button>
            </div>
            
            <div className="instructions-body">
              <div className="instruction-step">
                <div className="step-number">1</div>
                <div className="step-content">
                  <h3>Select Letters</h3>
                  <p>Click on letters in the grid to form words. You can only select letters that are next to each other (including diagonals).</p>
                </div>
              </div>
              
              <div className="instruction-step">
                <div className="step-number">2</div>
                <div className="step-content">
                  <h3>Follow the Path</h3>
                  <p>Each new letter must be adjacent to the previous one. The selected letters will light up to show your path.</p>
                </div>
              </div>
              
              <div className="instruction-step">
                <div className="step-number">3</div>
                <div className="step-content">
                  <h3>Form Valid Words</h3>
                  <p>Create words of 3 or more letters. Each letter can only be used once per puzzle.</p>
                </div>
              </div>
              
              <div className="instruction-step">
                <div className="step-number">4</div>
                <div className="step-content">
                  <h3>Submit & Score</h3>
                  <p>Click "Submit Word" to validate your word. Longer words give more points!</p>
                </div>
              </div>
              
              <div className="instruction-step">
                <div className="step-number">5</div>
                <div className="step-content">
                  <h3>Clear the Grid</h3>
                  <p>Use all letters to complete the puzzle. Plan your moves strategically!</p>
                </div>
              </div>
            </div>
            
            <div className="instructions-tips">
              <h3>💡 Tips</h3>
              <ul>
                <li>Look for longer words first - they give bonus points</li>
                <li>Plan your path to use letters efficiently</li>
                <li>Available letters will be highlighted when you select one</li>
                <li>Use the "Clear" button to start over if you make a mistake</li>
              </ul>
            </div>
            
            <div className="instructions-footer">
              <button className="got-it-button" onClick={onClose}>
                Got it! Let's play!
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Instructions;

